import FormSlide from '../FormSlide'

export default function LetsConnectSlide (props) {
  return (
    <FormSlide
      title='Let’s get you on Discord'
      stageName='Learning more about you'
      description='We use Discord as our primary tool for team collaboration and will need your Discord handle.'
      formData={[
        {
          src: '/imgs/discord.png',
          type: 'image',
          className: 'mb-3 w-100'
        },
        {
          text: 'What is your Discord name?',
          label: 'discordName',
          placeholder: 'Name#1234',
          type: 'discord-text-box'
        },
        {
          type: 'html',
          html:
            '<br/>Don\'t have one? <b><a class="link" href="https://discord.com/register" target="_blank">Sign up for Discord</a></b>'
        }
      ]}
      {...props}
    />
  )
}
